import { gettext } from '@eventbrite/i18n';

export const TITLE_DESKTOP = gettext('Live your best nightlife');
export const TITLE_MOBILE = gettext('Explore nightlife ');
export const TOUCHPOINT_DETAIL = gettext(
    'Discover the best things to do after dark near you.',
);

export const BUTTONS_DATA = [
    {
        title: gettext('Comedy & Shows'),
        subcategory: 'comedy-and-shows',
    },
    {
        title: gettext('Clubs & Parties'),
        subcategory: 'clubs-and-parties',
    },
    {
        title: gettext('Food & Drink'),
        subcategory: 'food-and-drink',
    },
];
